import Box from "@mui/material/Box";
import { type SxProps } from "@mui/material/styles";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

import { Typography } from "@/components/Typography";
import { PageLayout } from "@/pages/components/PageLayout";
import { PageTitle } from "@/pages/components/PageTitle";
import { VibeProjectCard } from "@/pages/vibeLab/components/VibeProjectCard";
import { mockVibeProjects } from "@/pages/vibeLab/data";

const styles = {
  header: {
    marginBottom: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  description: {
    fontSize: "16px",
    color: theme.colors.neutral070,
    margin: 0,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "24px",
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;

export const VibeLabPage: React.FC = function VibeLabPage() {
  return (
    <PageLayout>
      <Box sx={styles.header}>
        <PageTitle>🚀 CL Vibe Lab (Beta)</PageTitle>
        <Box sx={styles.description}>
          <Typography
            variant="h3"
            color={theme.colors.neutral070}
            fontWeight="regular"
          >
            此為漸強內部非技術夥伴的產品實驗，歡迎點擊查看內容。若您對某個專案感興趣，也歡迎點擊「我有興趣」，您的回饋將加速我們將點子排序並產品化！
          </Typography>
        </Box>
      </Box>

      <Box sx={styles.grid}>
        {mockVibeProjects.map((project) => (
          <VibeProjectCard key={project.id} data={project} />
        ))}
      </Box>
    </PageLayout>
  );
};
